module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide-up"
    }
  }, [_c('div', {
    staticClass: "sms-engagement"
  }, [_c('div', {
    staticClass: "_top"
  }, [_c('div', {
    staticClass: "_title"
  }, [_c('div', [_vm._v("SMS")]), _vm._v(" "), _c('div', [_vm._v("Conversation")])]), _vm._v(" "), _c('v-icon', {
    staticClass: "close-icon",
    on: {
      "click": _vm.closeEngagement
    }
  }, [_vm._v("\n        keyboard_arrow_down\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "message"
  }, [_c('div', {
    staticClass: "message-wrapper"
  }, [_c('user-tag', {
    attrs: {
      "user": _vm.currentUser,
      "showAvatar": "",
      "hideTick": "",
      "hideName": "",
      "width": "43",
      "height": "43"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "message-content"
  }, [_vm._v("Hello, test message")])], 1), _vm._v(" "), (_vm.attachment) ? _c('div', {
    staticClass: "attachment"
  }, [_c('v-icon', {
    staticClass: "attach-icon"
  }, [_vm._v("attachment")]), _vm._v(" "), _c('trackcardsimple', {
    attrs: {
      "item": _vm.attachment,
      "cover": '',
      "title": _vm.attachment.title,
      "subtitle": _vm.attachment.title,
      "coverRadius": "",
      "isVideo": _vm.attachType === 'Video'
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "_summary"
  }, [_c('div', {
    staticClass: "_detail"
  }, [_vm._v("\n          Delivered to\n          "), _c('strong', {
    staticClass: "recipientsLen"
  }, [_vm._v(_vm._s(_vm.recipientsLen) + " contacts via "), _c('strong', [_vm._v("SMS")])])]), _vm._v(" "), _c('div', {
    staticClass: "_time"
  }, [_vm._v(_vm._s(_vm._f("getTime")(new Date(Date.now()))))])])]), _vm._v(" "), _c('directory', {
    staticClass: "pt-0",
    attrs: {
      "customDirectory": [],
      "isComp": "",
      "height": 70,
      "separator": ""
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51152611","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/mobile/messages/SMS/smsEngagement.vue
// module id = 1720
// module chunks = 180